export const getIsReady = (state: AppState) => state.status === "STARTED";

const selectors = {
  getIsReady,
};

export default selectors;
